const isNonsupportedMessageType = (msg: Conversation.Message) => {
  if (msg.messageType === 'NONSUPPORT') {
    return true;
  }
  switch (msg.channel) {
    case 'TIKTOK':
    case 'TIKTOK_US': {
      const unsupportedMessageTypes: Conversation.Message['messageType'][] = ['STICKER'];
      return unsupportedMessageTypes.includes(msg.messageType);
    }
    default: {
      return false;
    }
  }
};

export default isNonsupportedMessageType;
